import { useEffect, useMemo, useState } from "react";
import { documentIcon, validateResponse } from "../documentsUtils"
import { DownIcon, DownloadFileIcon, EyeIcon, FolderIcon, SpinnerIcon, UpArrow } from "../../../icons";
import { CustomModal } from "../../../components/ui";
import { useDownloadDocument, useGetDocuments, useViewDocument } from "../../../hooks/react-query/useDocuments";
import { ServiceHistorySkeletion } from "../../../components/elements/skeletions/skeletions";
import { downloadDoc, getDocuments } from "../../../transactions/documents/documents";
import { toast } from "../../../components/ui/Toast/useToast";
import usePersonStore from "../../../store/personStore";

export const DosumentsSection = ({
    title="",
    section="",
    documentsList,
    isDocumentsLoading,
    selectedCar = null,
}) => {
    //we assume each doc row has icon, name, isExpandable flag, subdocuments and cta handler.
    const [expandedRows, setExpandedRows] = useState({});
    const [openLinkMocal, setOpenLinkModal] = useState(false)
    const [selectedLink, setSelectedLink] = useState({})
    const [isLinkLoading, setIsLinkLoading] = useState(false)

    const [activeDownloadId, setActiveDownloadId] = useState(null);
    const [activeViewId, setActiveViewId] = useState(null);
    const [activeLinkId, setActiveLinkId] = useState(null);
    const [hasSentEmail, setHasSentEmail] = useState(false)

    const [localDocumentsList, setLocalDocumentsList] = useState(documentsList ?? []);
    const userData = usePersonStore((store) => store.userData);

    const toggleRow = (rowId) => {
      setExpandedRows((prev) => ({
          ...prev,
          [rowId]: !prev[rowId],
      }));
    };

    const { mutate: downloadDocument, isLoading:isDownloadLoading } = useDownloadDocument();
    const { mutate: viewDocument, isLoading:isViewLoading } = useViewDocument();

    const enabled = (section === "client")
    const { data: quickdriver, isLoading: isQuickDriversLinkLoading } = useGetDocuments({categoryId:section === "client" ? "quick_driver_guide" : "", plateno:selectedCar?.plateno, enabled});

    useEffect(() => {
      setLocalDocumentsList(documentsList ?? []);
    }, [documentsList]);

    useEffect(()=>{
      setHasSentEmail(false)
    },[selectedCar])

    useEffect(() => {
      if (!quickdriver?.length) return;

      const quickDriverUrl = quickdriver?.[0]?.url ?? null;
      if (!quickDriverUrl) return;

      setLocalDocumentsList((prev) =>
        prev.map((item) =>
          (item?.category === "quick_driver_guide" || item?.category === "driver_confirmation")
            ? { ...item, url: quickDriverUrl }
            : item
        )
      );
    }, [quickdriver]);

    const handleDownload = (document) => {
      if(document?.category === "quick_driver_guide" && !isQuickDriversLinkLoading){
         window.open(quickdriver?.[0]?.url, "_blank", "noopener,noreferrer");
         return
      }
      if (!isDownloadLoading) {
        setActiveDownloadId(document?.id);
        downloadDocument(
        {
          uuid: document?.id,
          categoryId: document?.category,
          plateno: selectedCar?.plateno ?? null,
        },
        {
          onSettled: () => {
            setActiveDownloadId(null);
          },
        });
      }
    };

    const handleView = (document) => {
      if(document?.category === "quick_driver_guide" && !isQuickDriversLinkLoading){
         window.open(quickdriver?.[0]?.url, "_blank", "noopener,noreferrer");
         return
      }
      if (!isViewLoading) {
        setActiveViewId(document?.id);
        viewDocument(
        {
          uuid: document?.id,
          categoryId: document?.category,
          plateno: selectedCar?.plateno ?? null,
        },
        {
          onSettled: () => {
            setActiveViewId(null);
          },
        });
      }
    };

    const linkTexts = useMemo(()=> {
      switch (selectedLink?.category) {
        case "ev_free_parking_pass":
          return {
            title: selectedLink?.name,
            descriptionText: [
              "Αν το αυτοκίνητό σου είναι αμιγώς ηλεκτρικό ή υβριδικό εξωτερικής φόρτισης με εκπομπές ρύπων έως 50 γρ. CO2/χλμ, δικαιούσαι δωρεάν χρήση των θέσεων ελεγχόμενης στάθμευσης σε όλους τους δήμους της χώρας.",
              "Είναι απαραίτητο να εκτυπώσεις το ειδικό σήμα και να το τοποθετήσεις σε εμφανές μέρος του αυτοκινήτου.",
              "Επίλεξε «Είσοδος στην υπηρεσία» και «Σύνδεση» για ταυτοποίηση με τους προσωπικούς σου κωδικούς TAXISnet.",
              "Συμπλήρωσε τον αριθμό κυκλοφορίας του αυτοκινήτου και το ΑΦΜ 998106085. Πάτησε «Συνέχεια» για να εμφανιστεί η προεπισκόπηση και «Έκδοση» για να κατεβάσεις το σήμα.",
            ],
            ctaText : "Μετάβαση στο gov.gr",
            url: selectedLink?.url,
          }
        case "quick_driver_guide":
          return {
            title: selectedLink?.name,
            descriptionText: [
              "",
            ],
            ctaText : "Μετάβαση στο gov.gr",
            url: selectedLink?.url,
          }
        case "circulation_fee_payment_form":
          return {
            title: selectedLink?.name,
            descriptionText: [
              "Η πληρωμή των τελών κυκλοφορίας περιλαμβάνεται στο συμβόλαιό σου και γίνεται από την Avis. Τυχόν έλεγχος από τις αρχές πραγματοποιείται ηλεκτρονικά, δεν χρειάζεται να έχεις κάποιο έντυπο.",
              "Επίλεξε «Είσοδος στην Εφαρμογή», συμπλήρωσε το ΑΦΜ 998106085 και την πινακίδα του αυτοκινήτου και πάτησε «Εκτύπωση».",
            ],
            ctaText : "Μετάβαση στο gov.gr",
            url: selectedLink?.url,
          }
        case "inner_ring_pass":
          return {
            title: selectedLink?.name,
            descriptionText: [
              "Επίλεξε «Είσοδος στην υπηρεσία» και «Σύνδεση» για ταυτοποίηση με τους προσωπικούς σου κωδικούς TAXISnet.",
              "Συμπλήρωσε τον αριθμό κυκλοφορίας του αυτοκινήτου και το ΑΦΜ 998106085. Πάτησε «Συνέχεια» για να εμφανιστεί η επιβεβαίωση ελεύθερης κυκλοφορίας και «Έκδοση» αν θέλεις να κατεβάσεις το ειδικό σήμα.",
            ],
            ctaText : "Μετάβαση στο gov.gr",
            url: selectedLink?.url,
          }
        case "driver_confirmation":
          return {
            title: "Αποστολή email",
            descriptionText: [
              `Έχουμε στείλει τη βεβαίωσή σου στο email ${userData?.email}. Αν δεν το βρίσκεις, μπορείς να ελέγξεις τα ανεπιθύμητα μηνύματα.`,
            ],
            ctaText : "Επαναποστολή",
            url: selectedLink?.url,
          }
        default :
          return {
            title:"",
            descriptionText: ["",""],
            ctaText : "",
            url:"",
          }
      }
    },[selectedLink])

    if((section === "client") || (section === "links")) {
      if (localDocumentsList?.filter((doc) => {return doc?.category !== "quick_driver_guide"})?.length === 0 && isDocumentsLoading) {
        return <ServiceHistorySkeletion />
      } else if(localDocumentsList?.length === 0 && !isDocumentsLoading){
        return <p>{"Δεν υπάρχουν διαθέσιμα έγγραφα σε αυτήν την κατηγορία"}</p>
      }
    }
    
    return <div className='w-full bg-white rounded-xl p-4'>
        <h4 className='border-b border-[#E2E2E2] pb-3'>{title}</h4>
        <div>
        {!isDocumentsLoading && localDocumentsList?.length > 0 && localDocumentsList.map((item) => {
          const isExpandable = item.isExpandable;
          const isOpen = expandedRows[item.id];

          return (
            <div key={item.id} className="border-b last:border-b-0 border-[#E2E2E2]">
              {/* parent row */}
              <div className={`flex items-center justify-between py-2 ${["Link","Email"].includes(item?.type) ? "cursor-pointer" : ""}`}
                onClick={async ()=>{
                  if(["Link","Email"].includes(item?.type) && selectedLink?.category !== "quick_driver_guide")
                  {try {
                    setIsLinkLoading(true);
                    setActiveLinkId(item?.category);
                    const response = await getDocuments({
                      categoryId: item?.category,
                      plateno: selectedCar?.plateno,
                    });
                    if(validateResponse(response)) {
                      setSelectedLink({
                        ...item,
                        url: response?.[0]?.url,
                      });
                      setOpenLinkModal(selectedLink?.category !== "quick_driver_guide");
                    }
                  } catch (e) {
                    console.warn(e);
                  } finally {
                    setIsLinkLoading(false);
                    setActiveLinkId(null);
                  }}
                }}>
                <div className="flex items-center gap-3 min-w-0">
                  {isExpandable 
                    ? <div className='flex flex-row justify-center items-center p-2 bg-[#FEF2F2] rounded-full'><FolderIcon /></div>
                    : <div className='flex flex-row justify-center items-center p-2 bg-[#FEF2F2] rounded-full'>{documentIcon(item?.name)}</div>}
                  <p className="text-sm text-[#2C2C2C] truncate">{item.name}</p>
                  {isLinkLoading && activeLinkId === item?.category && <SpinnerIcon className="h-4 w-4 fill-fadedgrey"/>}
                </div>
                {item?.type === "Document" && <div className="shrink-0">
                  {isExpandable ? (
                    <button
                      type="button"
                      onClick={() => toggleRow(item.id)}
                      className="p-1"
                    >
                      {isOpen ? (
                        <UpArrow width='22' height='22' stroke='black' strokeWidth='2' />
                      ) : (
                        <DownIcon width={20} height={20} />
                      )}
                    </button>
                  ) : (
                    <div className="">
                      <button
                        disabled = {isViewLoading || isDownloadLoading}
                        type="button"
                        onClick={() => {
                          handleDownload(item)
                        }}
                        className="p-1 shrink-0"
                      >
                        <div className='flex flex-row justify-center items-center p-[6px] border border-fadedgrey rounded-full'>
                          {
                            isDownloadLoading && 
                            activeDownloadId === item?.id && 
                            (item?.category === "quick_driver_guide" && isQuickDriversLinkLoading) 
                              ? <SpinnerIcon className="w-5 h-5 fill-fadedgrey"/> 
                              : <DownloadFileIcon className="w-5 h-5 text-[#6A6A6A]" />
                          }
                        </div>
                        </button>
                        <button
                          disabled = {isViewLoading || isDownloadLoading}
                          type="button"
                          onClick={() => {
                            handleView(item)
                          }}
                          className="p-1 shrink-0"
                        >
                          <div className='flex flex-row justify-center items-center p-[6px] border border-fadedgrey rounded-full'>
                            {isViewLoading && activeViewId === item?.id ? <SpinnerIcon className="w-5 h-5 fill-fadedgrey"/> : <EyeIcon className="w-5 h-5 text-[#6A6A6A]" />}
                        </div>
                      </button>
                    </div>
                  )}
                </div>}
              </div>

              {/* children */}
              {isExpandable && isOpen && (
                <div>
                  {item?.subDocuments.map((child) => (
                    <div
                      key={child?.id}
                      className="flex items-center justify-between px-10 py-1"
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <div className='flex flex-row justify-center items-center p-2 bg-[#FEF2F2] rounded-full'>{documentIcon(child?.name)}</div>
                        <div className="min-w-0">
                          <span className="text-sm text-[#2C2C2C] truncate">
                            {child?.name} {" "}
                            {child?.metadata && (
                              <span className="text-xs text-[#8A8A8A] font-light">
                                Πινακίδα: {child?.metadata.filter((dato) => dato?.name === "Plate No")?.[0]?.value}
                              </span>
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="">
                        <button
                          disabled = {isViewLoading || isDownloadLoading}
                          type="button"
                          onClick={() => {
                            handleDownload(child)
                          }}
                          className="p-1 shrink-0"
                        >
                          <div className='flex flex-row justify-center items-center p-[6px] border border-fadedgrey rounded-full'>
                            {isDownloadLoading && activeDownloadId === child?.id ? <SpinnerIcon className="w-5 h-5 fill-fadedgrey"/> : <DownloadFileIcon className="w-5 h-5 text-[#6A6A6A]" />}
                          </div>
                          </button>
                          <button
                            disabled = {isViewLoading || isDownloadLoading}
                            type="button"
                            onClick={() => {
                              handleView(child)
                            }}
                            className="p-1 shrink-0"
                          >
                            <div className='flex flex-row justify-center items-center p-[6px] border border-fadedgrey rounded-full'>
                              {isViewLoading && activeViewId === child?.id ? <SpinnerIcon className="w-5 h-5 fill-fadedgrey"/> : <EyeIcon className="w-5 h-5 text-[#6A6A6A]" />}
                          </div>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <CustomModal
        triggerComponent={null} // No trigger component since the modal is opened programmatically
        wrapperClass=""
        handleClick={(value) => setOpenLinkModal(value)}
        openModal={openLinkMocal}
        >
          <div className="lg:py-12 py-5 px-8 flex flex-col w-full items-center lg:justify-center">
            <div className='w-full flex lg:justify-center'>
              {<h3 className="pb-11 text-center pr-3">{linkTexts?.title}</h3>}
            </div>
            <div className='lg:px-36 text-center m-auto flex flex-col gap-4 items-center'>
              {linkTexts?.descriptionText?.map((text)=><p className='text-center'>{text}</p>)}
            </div>
            <div className="flex max-lg:flex-col max-lg:w-[90%] pt-11">
              <button
                type="button"
                className={`px-10 py-3 ${selectedLink?.category === "driver_confirmation" && hasSentEmail ? "bg-fadedgrey" : "bg-primary "} text-white text-sm font-bold  rounded-lg`}
                onClick={async ()=>{
                  if(selectedLink?.type === "Link"){
                    window.open(selectedLink?.url, "_blank", "noopener,noreferrer");
                  } else if (selectedLink?.type === "Email") {
                    // handleDownload(selectedLink)
                    try{
                        // await getDocuments({categoryId:"driver_confirmation", plateno:selectedCar?.plateno})
                        await getDocuments({categoryId:selectedLink?.category, plateno:selectedCar?.plateno})
                      }catch(e){
                        console.warn(e)
                      } finally{
                        setHasSentEmail(true)
                      }
                  }
                }}
                disabled={selectedLink?.category === "driver_confirmation" && hasSentEmail}
              >
                {linkTexts?.ctaText}
              </button>
            </div>
          </div>
        </CustomModal>
    </div>
} 